import type {Branded} from '@kapitalist/utils/Branded'
import {brand} from '@kapitalist/utils/Branded'

declare const gameMoneyBrand: unique symbol

/** The game's main currency. */
export type TMillions = Branded<number, typeof gameMoneyBrand>

export const mkMillions = (millions: number): TMillions => brand<TMillions>(millions)

export const ZERO_M = mkMillions(0)
export const ONE_M = mkMillions(1)
export const TWO_M = mkMillions(2)
export const THREE_M = mkMillions(3)
export const FOUR_M = mkMillions(4)
export const FIVE_M = mkMillions(5)
export const SIX_M = mkMillions(6)
export const SEVEN_M = mkMillions(7)
export const EIGHT_M = mkMillions(8)
export const NINE_M = mkMillions(9)
export const TEN_M = mkMillions(10)
